import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export function certificateInfoApi() {
  return _certificateInfoApi.apply(this, arguments);
}
function _certificateInfoApi() {
  _certificateInfoApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", useGet('/certificateOrder/certificateInfoList'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _certificateInfoApi.apply(this, arguments);
}
export function logoutCertificateApi(_x) {
  return _logoutCertificateApi.apply(this, arguments);
}
function _logoutCertificateApi() {
  _logoutCertificateApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet("/certificateOrder/logoutCertificate/".concat(id)));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _logoutCertificateApi.apply(this, arguments);
}
export function certificateApi(_x2) {
  return _certificateApi.apply(this, arguments);
}
function _certificateApi() {
  _certificateApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(param) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", usePost("/web/searchCertificateList", param));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _certificateApi.apply(this, arguments);
}
export function examlUrlApi() {
  return _examlUrlApi.apply(this, arguments);
}
function _examlUrlApi() {
  _examlUrlApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", useGet('/member/findExamUrl'));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _examlUrlApi.apply(this, arguments);
}